import type { FallbackWidgetProps } from '@/types'
import { cn } from '@/utils/cn'

/**
 * FallbackWidget displays when an unknown widget type is encountered
 * or when widget data validation fails.
 */
export function FallbackWidget({ type, data }: FallbackWidgetProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-warning-500 bg-warning-50 p-4',
        'text-sm text-gray-700'
      )}
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-start gap-3">
        <span
          className="flex h-6 w-6 items-center justify-center rounded-full bg-warning-500 text-white"
          aria-hidden="true"
        >
          !
        </span>
        <div>
          <p className="font-medium text-gray-900">
            Unable to display content
          </p>
          <p className="mt-1">
            This content type ({type}) could not be rendered. Please try again or contact support if the issue persists.
          </p>
          {import.meta.env.DEV && (
            <details className="mt-3">
              <summary className="cursor-pointer text-xs text-gray-500 hover:text-gray-700">
                Debug info (dev only)
              </summary>
              <pre className="mt-2 max-h-40 overflow-auto rounded bg-gray-100 p-2 text-xs">
                {JSON.stringify({ type, data }, null, 2)}
              </pre>
            </details>
          )}
        </div>
      </div>
    </div>
  )
}
